export enum PaperCompanyValues {
    AdminOfficAddress = "adminOfficAddress",
    AgentServicesPhoneNumber = "agentServicesPhoneNumber",
    CompanyName = "companyName",
    CustomerPortalPhoneNumber = "customerPortalPhoneNumber",
    CustomerPortalFooterParagraphOne = "customerPortalFooterParagraphOne",
    CustomerPortalFooterParagraphTwo = "customerPortalFooterParagraphTwo",
    CustomerPortalWebsiteLinkingAgreementLink = "customerPortalWebsiteLinkingAgreementLink",
    CustomerPortalSitemapLink = "customerPortalSitemapLink",
    CustomerPortalSiteStatusLink = "customerPortalSiteStatusLink",
    PrivacyPolicyUrl = "privacyPolicyUrl",
    CompanyShortName = "companyShortName",
    LegalUrl = "legalUrl",
    CustomerPortal = "customerPortal",
    FaxNumber = "faxNumber",
    HomeOffice = "homeOffice",
    LockboxPaymentAddress = "lockboxPaymentAddress",
    OvernightAddress = "overnightAddress",
    PoBoxAddress = "poBoxAddress",
    PreissueServicingContactAWD = "preissueServicingContactAWD",
    PreissueServicingContactChorus = "preissueServicingContactChorus",
    Website = "website"
}
